import React from 'react';
import { useTranslation } from 'react-i18next';
import CreatableSelect from 'react-select/creatable';
import ReactTooltip from 'react-tooltip';
import Select, { components } from 'react-select';

import { SelectBoxDefaultProps, SelectBoxPropTypes } from 'src/components/SelectBox/propTypes';
import defaults from 'src/components/SelectBox/SelectBox.styles';
import pages from 'src/components/SelectBox/PaginationSelectBox.styles';

const MultiValueLabel = props => (
  <React.Fragment>
    <div
      data-for={props?.data?.value?.toString()}
      data-tip={true}
      style={{
        ...(props?.data?.isDisabled ? {
          color: '#fff',
          opacity: 0.5,
          textDecoration: 'line-through',
        } : {})
      }}
    >
      <components.MultiValueLabel {...props} />
    </div>
    <ReactTooltip id={props?.data?.value?.toString()}>
      {props?.data?.label}
    </ReactTooltip>
  </React.Fragment>
);

const SelectBox = ({
  action,
  components: componentsProps,
  disabled,
  error,
  flash,
  invisible,
  isCreatable,
  isLoading,
  label,
  pageStyle,
  required,
  errorShowOnTop,
  ...rest
}) => {
  const { t } = useTranslation();
  const s = pageStyle ? pages : defaults;

  return (
    <s.SelectBox invisible={invisible}>
      {label && (
        <s.SelectBoxLabel>
          {label}
          {required && <s.SelectBoxRequired>*</s.SelectBoxRequired>}
        </s.SelectBoxLabel>
      )}
      <s.SelectBoxContainer >
        {isCreatable ? (
          <CreatableSelect
            className={s.Stylesheets['react-select-container']}
            classNamePrefix={s.Stylesheets['react-select']}
            {...rest}
          />
        ) : (
          <Select
            className={s.Stylesheets['react-select-container']}
            classNamePrefix={s.Stylesheets['react-select']}
            components={{
              ...(componentsProps || {}),
              MultiValueLabel,
            }}
            isDisabled={disabled}
            isLoading={isLoading}
            noOptionsMessage={() => t('SELECT_NO_OPTIONS')}
            placeholder={t('SELECT_PLACEHOLDER')}
            styles={{
              singleValue: base => ({
                ...base,
                ...(rest?.value?.isDisabled ? {
                  opacity: 0.5,
                  textDecoration: 'line-through',
                } : {}),
              }),
            }}
            {...rest}
          />
        )}
      </s.SelectBoxContainer>
      {action || ''}
      {error && <s.SelectBoxError errorShowOnTop={errorShowOnTop}>{error}</s.SelectBoxError>}
    </s.SelectBox>
  );
};

SelectBox.propTypes = SelectBoxPropTypes;
SelectBox.defaultProps = SelectBoxDefaultProps;

export default React.memo(SelectBox);
